import React, { useState, useRef } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { useNavigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { QuestionData } from "../../Redux/Reducers/QBAdmin/EditQuestions";
import { useSelector, useDispatch } from "react-redux";
import QBLOFilters from "./Filters";
import {
  Languages,
  TabViewValues,
} from "../../ReusableComponents/CommonFunctions";
import { SelectLanguageData } from "../../Redux/Reducers/Common/Language";
import { QBTopic } from "../../ReusableComponents/QBDropdowns";

const QuestionBank = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const childRef = useRef();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const [STab, SetSTab] = useState(location.state?.Tab || "SCQ");
  const [LoFilters, SetLoFilters] = useState(
    JSON.parse(localStorage.getItem("LoFilters")) || false
  );
  const [TabType, SeTabType] = useState("SCQ");
  const [Topic, SeTopic] = useState();

  const ChangeTab = (e, topic) => {
    if (childRef.current) {
      childRef.current.ClearAllSTates();
    }
    localStorage.removeItem("FSelected");
    SetSTab(e);
    if (LoFilters && items.subjectId === "2") {
      switch (e) {
        case "SCQ":
          SeTabType("SCQ");
          navigate(`/QBAdmin/QuestionBank/ScienceFilters`, {
            state: {
              Tab: "SCQ",
              Topic: topic || Topic,
              SList: 1,
            },
          });
          break;
        case "DQ":
          localStorage.removeItem("DPageCount");
          SeTabType("DQ");
          return navigate(`/QBAdmin/QuestionBank/ScienceFilters`, {
            state: { Tab: "DQ", Topic: topic || Topic },
          });
        case "INQ":
          SeTabType("INQ");
          return navigate(`/QBAdmin/QuestionBank/ScienceFilters`, {
            state: { Tab: "INQ" },
          });
      }
    } else {
      switch (e) {
        case "SCQ":
          SeTabType("SCQ");
          navigate(`/QBAdmin/QuestionBank`, {
            state: {
              Tab: "SCQ",
              Topic: topic || Topic,
              SList: 1,
            },
          });
          break;
        case "DQ":
          SeTabType("DQ");
          localStorage.removeItem("DPageCount");
          dispatch(QuestionData({ QuestionDetails: "" }));
          return navigate(`/QBAdmin/QuestionBank/DirectQuestions`, {
            state: { Tab: "DQ", Topic: topic || Topic },
          });
        case "INQ":
          SeTabType("INQ");
          return navigate(`/QBAdmin/QuestionBank/InputBasedQuestions`, {
            state: { Tab: "INQ" },
          });
      }
    }
  };
  const StoreFilters = (FState) => {
    localStorage.setItem("LoFilters", FState);
    const GetENglish = JSON.parse(localStorage.getItem("LanguageOptions")).filter((item)=>(item?.display === "English"))
    dispatch(SelectLanguageData({ SLanguage: GetENglish?.[0]?.value }));
    localStorage.removeItem("FSelected");
    localStorage.removeItem("FINQSNS");
    SetLoFilters(FState);
    if (!FState) {
      navigate(`/QBAdmin/QuestionBank`, {
        state: { Tab: "SCQ", Topic: Topic, SList: 1 },
      });
    }
    if (FState && items.subjectId === "2") {
      navigate(`/QBAdmin/QuestionBank/ScienceFilters`, {
        state: { Tab: "SCQ" },
      });
    }
  }; 

  const Tabcode = () => {
    switch (location.state?.Tab || "SCQ") {
      case "SCQ":
        return "SCQ";
      case "DQ":
        return "DQ";
      case "INQ":
        return "INQ";
    }
  };
  const Tabs = [
    { Name: "Scenario based Questions", Value: "SCQ" },
    { Name: "Direct Questions", Value: "DQ" },
    { Name: "Input based Questions", Value: "INQ" },
  ];
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex JCCenter" style={{ gap: "15px" }}>
          {[false, true].map((Item) => (
            <div className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                name="Lo"
                checked={Item === LoFilters}
                value={Item}
                onChange={() => StoreFilters(!LoFilters)}
              />{" "}
              <b>{Item ? "Apply filters to QB" : "Question Bank"}</b>
            </div>
          ))}
        </div>

        <TabViewValues
          Tabs={Tabs}
          Selectedtab={location.state?.Tab || STab}
          onClick={(e) => ChangeTab(e)}
        />
        {LoFilters && (!location.pathname.includes("/QBAdmin/QuestionBank") || location.pathname.includes("/Remidation") 
      || location.pathname.includes("/AddEditScenario") || location.pathname.includes("/AddUpdateQuestions"))&& (<> {items?.subjectName} &gt;{FQuestionDetails.topicName} &gt; {FQuestionDetails.subTopicName}{" "}
          &gt; <b className="text-success"> {FQuestionDetails.loName}</b></>)}


        {!LoFilters &&
          !location.pathname.includes("/ScienceFilters") &&
          !location.pathname.includes("/TranslateQuestion") &&
          !location.pathname.includes("/AddUpdateQuestions") &&
          !location.pathname.includes("/TranslateScenario") &&
          !location.pathname.includes("/ScenarioQuestions") &&
          !location.pathname.includes("/AddEditScenario") &&
          !location.pathname.includes("/CloneAddQuestion") && (
            <div className="dflex gap-3" style={{ justifyContent: "end" }}>
              <div>
                {!location.pathname.includes("/InputBasedQuestions") && (
                  <QBTopic
                    className="NCLDropdown Width15"
                    SubjectId={items?.subjectId}
                    PId={items?.subjectId === "1" ? "" : "0"}
                    StoreValue={SeTopic}
                    LID={SelectLanguage}
                    labelName={<div className="DropdownHeader">Topic</div>}
                    SOption={Topic}
                    onChange={(e) => {
                      SeTopic(e);
                      ChangeTab(location.state?.Tab || STab, e);
                    }}
                    LovCategoryId={items?.subjectId === "1" ? 4 : 25}
                  />
                )}
              </div>
              <div>
                <Languages
                  onChange={(e) => {
                    dispatch(SelectLanguageData({ SLanguage: parseInt(e) }));
                  }}
                  labelname={
                    <div className="DropdownHeader">Select Language</div>
                  }
                />
              </div>
            </div>
          )}
        {LoFilters &&
          items.subjectId === "1" &&
          !location.pathname.includes("/FilterScenarioQuestions") &&
          !location.pathname.includes("/AddUpdateQuestions") &&
          !location.pathname.includes("/CloneAddQuestion") &&
          !location.pathname.includes("/AddEditScenario") &&
          !location.pathname.includes("/Remidation")
          ? (
            <QBLOFilters ref={childRef} TType={Tabcode() || location.state.Tab} />
          ) : (
            <Outlet />
          )}
      </div>
    </>
  );
};
export default QuestionBank;
